export const onSuccess = (commit, message) => {
  window.$vue.$toast({
    type: "success",
    title: message
  })
  commit("updateLoading", { show: false })
  commit("setAlreadySaved", true)
}

export const onError = (event, message, commit) => {
  window.$vue.$toast({
    type: "error",
    title: `${message} ${event.target.error}`
  })
  commit("updateLoading", { show: false })
}

export const getDbFromEvent = event => event.target.result

const startTransaction = (event, mode, table) => {
  return getDbFromEvent(event).transaction(table, mode)
}

const getObjectStore = (event, mode, table) => {
  const transaction = startTransaction(event, mode, table)
  return transaction.objectStore(table)
}

export const getSaleObjectStore = (event, mode, table) => {
  return getObjectStore(event, mode, table)
}

export const hasSalesStore = objectStoreNames =>
  objectStoreNames.contains("sales")
